// Regole condivise per la tipologia ospite (Questura/AlloggiatiWeb + ROSS1000/ISTAT):
//  - 1 ospite totale   -> SEMPRE "Singolo"
//  - 2+ ospiti totali  -> esattamente UN capo (Capofamiglia o Capogruppo);
//    gli altri devono essere familiari o membri del gruppo.
// Usate sia nel self check-in (GuestCheckin) sia nella vista operatore (GuestVerificationModal).

export const HEAD_GUEST_TYPES = ['family_head', 'group_leader'];
export const MEMBER_GUEST_TYPES = ['family_member', 'group_member'];

const _norm = (v) => (v || '').toString().toLowerCase();
const _isHead = (v) => HEAD_GUEST_TYPES.includes(_norm(v));

// Tipi selezionabili per l'ospite corrente, dati il totale ospiti e i tipi
// già scelti dagli ALTRI ospiti (escluso quello corrente).
export function allowedGuestTypes(totalGuests, otherGuestTypes = []) {
  if (!totalGuests || totalGuests <= 1) return ['single'];
  const hasOtherHead = otherGuestTypes.some(_isHead);
  const allowed = [...MEMBER_GUEST_TYPES];
  if (!hasOtherHead) allowed.unshift(...HEAD_GUEST_TYPES);
  return allowed; // "single" non è mai ammesso con 2+ ospiti
}

export function isGuestTypeDisabled(value, totalGuests, otherGuestTypes = []) {
  return !allowedGuestTypes(totalGuests, otherGuestTypes).includes(value);
}

// Valida la SCELTA dell'ospite corrente. Ritorna un codice errore o null.
export function validateGuestTypeSelection(currentType, totalGuests, otherGuestTypes = []) {
  const t = _norm(currentType);
  if (!totalGuests || totalGuests <= 1) {
    return t === 'single' ? null : 'must_be_single';
  }
  if (t === 'single') return 'single_not_allowed';
  if (_isHead(t) && otherGuestTypes.some(_isHead)) return 'multiple_heads';
  return null;
}

// Valida l'insieme COMPLETO dei tipi (usata sull'ultimo ospite / prima dell'invio).
export function validateAllGuestTypes(guestTypes = [], totalGuests) {
  if (!totalGuests || totalGuests <= 1) return null;
  const heads = guestTypes.filter(_isHead).length;
  if (heads === 0) return 'no_head';
  if (heads > 1) return 'multiple_heads';
  return null;
}
